export default function BlueMountainSection(){
    return(
        <section className="coffee-section">
            <div className="section-header">
                <h2>Jamaica Blue Mountain</h2>
                <div className="divider"></div>
            </div>

            <div className="coffee-grid">
                <div className="coffee-card">
                    <div className="card-num">01</div>
                    <h3>Kraljevsko Poreklo</h3>
                    <p>Uzgajana u maglovitim vrhovima Plavih Planina Jamajke na preko 2.000 metara nadmorske visine. Specifično vulkansko tlo i hladnija klima usporavaju sazrevanje, dajući zrnu neverovatnu dubinu ukusa.</p>
                </div>

                <div className="coffee-card highlight">
                    <div className="card-num">02</div>
                    <h3>Ručna Selekcija</h3>
                    <p>Svako zrno prolazi kroz rigoroznu ručnu inspekciju. Biraju se samo najsavršeniji plodovi, što garantuje šoljicu kafe bez ijedne trunke gorčine, sa glatkom i baršunastom teksturom.</p>
                </div>

                <div className="coffee-card">
                    <div className="card-num">03</div>
                    <h3>Profil Ukusa</h3>
                    <p>Ono što je čini najskupljom na svetu je balans blage kiselosti i slatkoće. Dominiraju note cvetnih aroma, čokolade i orašastih plodova koje ostaju dugo na nepcima.</p>
                </div>
            </div>
        </section>
    )
}